import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ColorSchemeScript, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles/global.css';

import { theme } from './lib/theme';
import { App } from './App';
import { QueryProvider } from './lib/query-client';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

const head = document.head;
const scriptEl = document.createElement('div');
head.appendChild(scriptEl);

createRoot(rootEl).render(
  <StrictMode>
    <ColorSchemeScript defaultColorScheme="auto" />
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <Notifications position="top-right" />
      <QueryProvider>
        <App />
      </QueryProvider>
    </MantineProvider>
  </StrictMode>,
);
